export default {
	ADD_MESSAGE: 'ADD_MESSAGE',
	REMOVE_MESSAGE: 'REMOVE_MESSAGE'
};
